import type { FilterType, UiOperator } from "./types";

const STRING_OPERATORS: UiOperator[] = [
  "contains",
  "does not contain",
  "starts with",
  "ends with",
  "=",
  "!=",
  "in",
  "not in",
  "is blank",
  "is not blank",
];

const NUMBER_OPERATORS: UiOperator[] = [
  "=",
  "!=",
  "<",
  "<=",
  ">",
  ">=",
  "in",
  "not in",
  "between",
  "not between",
  "is blank",
  "is not blank",
];

const DATE_OPERATORS: UiOperator[] = [
  "=",
  "!=",
  "<",
  "<=",
  ">",
  ">=",
  "between",
  "not between",
  "is blank",
  "is not blank",
];

/** Default operator choices per column type (pages may pass a narrower set). */
export const OPERATORS_BY_TYPE: Record<FilterType, UiOperator[]> = {
  string: STRING_OPERATORS,
  number: NUMBER_OPERATORS,
  boolean: ["=", "!=", "is blank", "is not blank"],
  date: DATE_OPERATORS,
  datetime: DATE_OPERATORS,
  duration: NUMBER_OPERATORS,
  unknown: STRING_OPERATORS,
};

/** Operators that take no value (the value input is disabled). */
export const NO_VALUE_OPERATORS: ReadonlySet<UiOperator> = new Set([
  "is blank",
  "is not blank",
]);

/** Operators that take a start + end value pair. */
export const RANGE_VALUE_OPERATORS: ReadonlySet<UiOperator> = new Set([
  "between",
  "not between",
]);

/** Display labels for the operator dropdown (values stay the UiOperator
 *  tokens — persisted specs and tests key on values, not labels). */
export const OPERATOR_LABELS: Record<UiOperator, string> = {
  contains: "Contains",
  "does not contain": "Does not contain",
  "starts with": "Starts with",
  "ends with": "Ends with",
  "=": "Equals",
  "!=": "Not equal",
  "<": "Less than",
  "<=": "Less than or equal",
  ">": "Greater than",
  ">=": "Greater than or equal",
  in: "In",
  "not in": "Not in",
  between: "Between",
  "not between": "Not between",
  "is blank": "Is blank",
  "is not blank": "Is not blank",
};
